// extracted by mini-css-extract-plugin
export default {"games":"Games_games__yj6EP","games_title":"Games_games_title__lCGb0"};